import {getUrlParam, setOrDeleteStringParam} from '@hconnect/common/utils'
import {useSearchParams} from 'react-router'

export const useMonthState = (paramName: string, defaultValue: number) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const monthParam = getUrlParam(searchParams, paramName)
  const month =
    monthParam !== undefined && /^\d+$/.test(monthParam) ? Number(monthParam) : defaultValue

  const setMonth = (value: string) => {
    const newParams = new URLSearchParams(searchParams)

    setOrDeleteStringParam(newParams, paramName, value)
    setSearchParams(newParams)
  }

  return {month, setMonth}
}
